import { 
    SET_KPI
} from '../actions/action-types';
import { v4 } from 'uuid';

// Inital zoom and center
const initialState = {
    refresh: v4()
};

export default function(state = initialState, action:any){
    switch(action.type){
        case SET_KPI:
            return{
                ...state,
                ...action.payload
            }
        default:
            return state;
    }
}